/**
 * The entry point the unrated journeys module
 */
export const initialise = () => {

  angular.module('app.usage-rating-rules').config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    ($stateProvider, $urlRouterProvider, $locationProvider) => {
      $locationProvider.hashPrefix('');

      $stateProvider.state('usage-rating-rules', {
        url: '/usage-rating-rules',
        templateUrl: 'app/angularJS/features/abt/usage-rating-rules/usage-rating-rules.html',
        controller: 'UsageRatingRulesController',
        controllerAs: 'vm',
        parent: 'common'
      });

      $urlRouterProvider.otherwise('/');
    }]);
};